import axios from 'axios';
import { getToken } from '../../includes/auth';
import { useNotification } from '../contexts/NotificationContext';

const getApi = () => {

  switch (window.rucmonkeyGlobalConfigs?.serviceUrl) {
  case "STAGING":
    return process.env.REACT_APP_SERVICE_STAGING;
  case "STAGING2":
    return process.env.REACT_APP_SERVICE_STAGING2;
  case "PROD":
    return process.env.REACT_APP_SERVICE_PROD;
  default:
    return process.env.REACT_APP_SERVICE_LOCAL;
  }
};

axios.defaults.baseURL = getApi();

const useAxiosAuth = () => {

  const { showError } = useNotification();


  if (axios.interceptors.hasAuthErrorHandler) {
    return;
  }
  axios.interceptors.hasAuthErrorHandler = true;

  // Add a request interceptor
  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }



    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      console.log(
        "==============Error:",
        err.response
      );

      if (err?.response?.status === 401) {


        window.location.href = "/login";

      } else if (err?.response?.status === 400 || err?.response?.status === 500) {

        showError({
          title: "Something's wrong",
          content: err.response.data.Errors ? err.response.data.Errors[0].Error : err.response.statusText,
          timeout: 10000
        });
      } else if (err?.response?.status !== 470) {
        showError({
          title: "Something's wrong",
          timeout: 4000
        });
      }

      throw err.response;
    });
};

export default useAxiosAuth;
